import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { apiClient, setCustomerToken } from '../../../api/client';
import { CustomerUser } from '../../../types';
import { customerAuthActions } from './index';

function* loginSaga(action: ReturnType<typeof customerAuthActions.loginRequest>) {
  try {
    const { data } = yield call(apiClient.post, '/api/auth/login', action.payload);
    setCustomerToken(data.token);
    yield put(customerAuthActions.loginSuccess({ user: data.user as CustomerUser, token: data.token }));
  } catch (err: unknown) {
    const response = (err as { response?: { data?: { message?: string; code?: string } } })?.response?.data;
    const message = response?.message || 'Login failed';
    yield put(customerAuthActions.loginFailure({ message, code: response?.code }));
  }
}

function* registerSaga(action: ReturnType<typeof customerAuthActions.registerRequest>) {
  try {
    const { data } = yield call(apiClient.post, '/api/auth/register', action.payload);
    yield put(
      customerAuthActions.registerSuccess({
        message: data.message as string,
        email: data.email as string,
      }),
    );
  } catch (err: unknown) {
    const message =
      (err as { response?: { data?: { message?: string } } })?.response?.data?.message ||
      'Registration failed';
    yield put(customerAuthActions.registerFailure(message));
  }
}

function* fetchMeSaga() {
  try {
    const { data } = yield call(apiClient.get, '/api/auth/me');
    yield put(customerAuthActions.setUser(data.user as CustomerUser));
  } catch {
    yield put(customerAuthActions.logout());
    setCustomerToken(null);
  }
}

function* customerAuthBootstrapSaga() {
  const token = localStorage.getItem('sportshub_customer_token');
  if (token) {
    setCustomerToken(token);
    yield call(fetchMeSaga);
  } else {
    yield put(customerAuthActions.setBootstrapping(false));
  }
}

export function* customerAuthSaga() {
  yield fork(customerAuthBootstrapSaga);
  yield takeLatest(customerAuthActions.loginRequest.type, loginSaga);
  yield takeLatest(customerAuthActions.registerRequest.type, registerSaga);
}
